'use client';

import { createContext } from 'react';
import { ContentAssetKeys } from '@headless-workspace/core-domain';
import { FunctionHelpers } from '@headless-workspace/utils';
import { ContentAssetType, PopularSearchValue } from '../../../../server';
import { ClientConfigsRecord, ConfigKey } from './ClientConfigsRecord';
import { ClientEnvKey, ClientEnvKeysRecord } from './ClientEnvKeysRecord';
import { ClientFlagsRecordKey } from './ClientFlagsRecord';

export type ClientDataContextValueType = {
    clientEnvs: ClientEnvKeysRecord;
    getClientEnvVariable: (ClientEnvKey: ClientEnvKey) => string;
    getClientFlags: (key: ClientFlagsRecordKey) => boolean;
    getContentAssets: (id: ContentAssetKeys) => ContentAssetType | undefined;
    clientValues: {
        popularSearches: PopularSearchValue[];
    };
    getClientConfigs: <K extends ConfigKey>(id: K) => ClientConfigsRecord[K] | undefined;
};

const ClientDataContextInitialState: ClientDataContextValueType = {
    clientEnvs: {
        [ClientEnvKey.BooxiKey]: '',
        [ClientEnvKey.WoosmapApiBaseUrl]: '',
        [ClientEnvKey.WoosmapKey]: '',
        [ClientEnvKey.ClientApiKey]: '',
        [ClientEnvKey.RuntimeEnvironment]: '',
        [ClientEnvKey.BuildEnvironment]: '',
        [ClientEnvKey.EkooWebsiteId]: '',
    },
    getClientConfigs: () => undefined,
    getClientEnvVariable: () => '',
    getClientFlags: () => false,
    getContentAssets: FunctionHelpers.undefinedFn,
    clientValues: {
        popularSearches: [],
    },
};

export const ClientDataContext = createContext<ClientDataContextValueType>(ClientDataContextInitialState);
